import { observer } from "mobx-react-lite"
import { Helmet } from "react-helmet";
import ClearChaos from "./AboutBlocks/ClearChaos";
import EventsCalendar from "./AboutBlocks/EventsCalendar";
import KanbanView from "./AboutBlocks/KanbanView";
import CustomAccess from "./AboutBlocks/CustomAccess";
import SkTechHistory from "./AboutBlocks/SkTechHistory";
import MobileApps from "./AboutBlocks/MobileApps";
import ReadyStart from "./AboutBlocks/ReadyStart";
const AboutEN = observer(() => {
    return (
        <div className="about">
            <Helmet>
                <meta name="description" content="About SkTech SANPOINT IT SOLUTIONS" />
            </Helmet>
            <ClearChaos />
            <EventsCalendar />
            <KanbanView />
            <CustomAccess/>
            <SkTechHistory/>
            <MobileApps/>
            <ReadyStart/>
        </div>
    )
})
export default AboutEN;